// @ts-nocheck
// Page: consent-ach  (ACH bank deposit verification step)
//
// Ported from the inline <script> in
//   Enrollment_modules/consent-ach/verification.module/module.html (lines 85–717).
//
// MECHANICAL PORT — runtime behaviour is preserved. Deliberate changes:
//   1. Inline oninput handler stripped from #descriptorCode and re-bound
//      root-scoped via bind() at end of init.
//   2. enrollment.nautilussolar.com/_hcms/api/* -> apiUrl() (5 URLs).
//   3. Same-origin redirects -> root-relative paths.
//   4. localStorage -> storage.rawGet/rawSet/rawRemove.
//   5. @ts-nocheck for bare-minimum migration; proper typing is a follow-up.
// NOTE: stripe.nautilussolar.com URLs kept literal (no __ENV__ key).

import { apiUrl } from "../../core/api"
import * as storage from "../../core/storage"
import { beginOperation, type LoadingOperationHandle } from "../../ui/loading-modal"

export function init(root: HTMLElement, _config: unknown): void {
__ea_trace("modules/consent/consent-ach.ts","init",[root,_config],["root","_config"]);
  const bind = (sel: string, type: string, fn: (e: any) => void) => {
__ea_trace("modules/consent/consent-ach.ts","bind",[sel,type,fn],["sel","type","fn"]);
    const el = root.querySelector(sel)
    if (el) el.addEventListener(type, fn)
  }

  // ─── Loading modal ─────────────────────────────────────────────────────────
  // Mechanical migration of the former fake-timer progress bar to the shared,
  // accessible loading modal (js/src/ui/loading-modal.ts). Kind "mutation" so a
  // genuine hang shows honest "may still be processing" copy with a Close escape,
  // never a fabricated 100%. The former 15s/30s message swaps and the
  // interval-leak are gone by construction. A deferred audit will split this into
  // read vs mutation withLoader boundaries with abort/idempotency semantics.
  let loaderHandle: LoadingOperationHandle | null = null
  function openProgressBar(message = "We are getting in contact with your utility service provider."): void {
__ea_trace("modules/consent/consent-ach.ts","openProgressBar",[message],["message"]);
    loaderHandle = beginOperation({ kind: "mutation", message })
  }
  function closeProgressBar(): void {
__ea_trace("modules/consent/consent-ach.ts","closeProgressBar",[],[]);
    loaderHandle?.complete()
    loaderHandle = null
  }

  var responseFromAPI = ""
  // If user is not logedIn then redirected them to login page -------------------------------------------------
  function getEmail() {
__ea_trace("modules/consent/consent-ach.ts","getEmail",[],[]);
    var storedEmail = storage.rawGet("userEmail")
    if (!storedEmail) {
      window.location.href = "/"
      return false
    }
  }
  getEmail()
  // If user is not logedIn then redirected them to login page -------------------------------------------------

  /* loader function */
  function _pageFoundOpenLoader() {
__ea_trace("modules/consent/consent-ach.ts","_pageFoundOpenLoader",[],[]);
    var loader = document.getElementById("myUsageLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("MUloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent-ach.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent-ach.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = true
    })
  }
  function _pageFoundCloseLoader() {
__ea_trace("modules/consent/consent-ach.ts","_pageFoundCloseLoader",[],[]);
    var loader = document.getElementById("myUsageLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("MUloaderOverlay").style.display = "none"
    loader.style.display = "none"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent-ach.ts","(anon)",[button],["button"]);
      button.disabled = false
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent-ach.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = false
    })
  }
  function _passUpdatedOpenLoader() {
__ea_trace("modules/consent/consent-ach.ts","_passUpdatedOpenLoader",[],[]);
    var loader = document.getElementById("PassUpdatedresetPassLoader")
    var _body = document.querySelector("body")
    var buttons = document.querySelectorAll("button")
    var anchors = document.querySelectorAll("a")
    document.getElementById("PassUpdatedloaderOverlay").style.display = "block"
    loader.style.display = "flex"
    buttons.forEach((button) => {
__ea_trace("modules/consent/consent-ach.ts","(anon)",[button],["button"]);
      button.disabled = true
    })
    anchors.forEach((anchor) => {
__ea_trace("modules/consent/consent-ach.ts","(anon)",[anchor],["anchor"]);
      anchor.disabled = true
    })
  }
  /* loader function */

  var paymentMethodId = ""
  var _paymentMethod = ""
  var paymentId = ""
  var skipBayou = ""
  var microdepostiType = ""
  async function GetPaymentMethodId() {
__ea_trace("modules/consent/consent-ach.ts","GetPaymentMethodId",[],[]);
    openProgressBar()
    //         var email = storage.rawGet("userEmail");
    var dealId = storage.rawGet("dealId")
    var _catchdata = ""
    try {
      const data = {
        deal_id: dealId,
      }
      const response = await fetch(apiUrl("GetDealRecordBasedOnEmail"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      _catchdata = data
      const dataa = await response.json()
      responseFromAPI = JSON.stringify(dataa)

      if (dataa.message === "User Found") {
        paymentMethodId = dataa.userValue.properties.stripe_payment_method_id
        paymentMethodId = paymentMethodId
        _paymentMethod = dataa.userValue.properties.stripe_payment_method
        paymentId = dataa.userValue.properties.stripe_payment_id
        skipBayou = dataa.userValue.properties.skip_bayou_submission
        microdepostiType = dataa.userValue.properties.microdeposit_type
        paymentId = paymentId
        closeProgressBar()
        if (microdepostiType === "amounts") {
          document.getElementById("ACHDepositAmount1").style.display = "block"
          document.getElementById("ACHDepositAmount2").style.display = "block"
          document.getElementById("descriptorCode").style.display = "none"
          document.getElementById("descriptorCodeLabel").style.display = "none"
        } else if (microdepostiType === "descriptor_code") {
          document.getElementById("ACHDepositAmount1").style.display = "none"
          document.getElementById("ACHDepositAmount2").style.display = "none"
          document.getElementById("descriptorCode").style.display = "block"
          document.getElementById("descriptorCodeLabel").style.display = "block"
        } else {
          document.getElementById("ACHDepositAmount1").style.display = "block"
          document.getElementById("ACHDepositAmount2").style.display = "block"
          document.getElementById("descriptorCode").style.display = "none"
          document.getElementById("descriptorCodeLabel").style.display = "none"
        }
      }
    } catch (error) {
      console.error("Error:", error)
    }
  }

  function enforceTwoTwoFormat(inputId, errorId) {
__ea_trace("modules/consent/consent-ach.ts","enforceTwoTwoFormat",[inputId,errorId],["inputId","errorId"]);
    const input = document.getElementById(inputId)
    const error = document.getElementById(errorId)

    input.addEventListener("input", (e) => {
__ea_trace("modules/consent/consent-ach.ts","(anon)",[e],["e"]);
      let val = e.target.value

      // Remove all non-numeric and non-dot characters
      val = val.replace(/[^0-9.]/g, "")

      // Enforce only one dot
      const dotIndex = val.indexOf(".")
      if (dotIndex !== -1) {
        const beforeDot = val.substring(0, dotIndex).slice(0, 2) // Max 2 digits before dot
        const afterDot = val.substring(dotIndex + 1).slice(0, 2) // Max 2 digits after dot
        val = `${beforeDot}.${afterDot}`
      } else {
        // If no dot, allow max 2 digits only
        val = val.slice(0, 2)
      }

      input.value = val

      // New pattern: allow 0 to 2 digits before, exactly 2 digits after
      // Examples valid: ".33", "0.33", "00.33", "11.33"
      const validPattern = /^(\d{0,2})\.\d{2}$/
      if (!validPattern.test(val)) {
        error.textContent = "Enter a valid amount in format: .33, 0.33, or 11.33"
        input.style.borderColor = "red"
      } else {
        error.textContent = ""
        input.style.borderColor = ""
      }
    })
  }

  // Apply to both inputs
  enforceTwoTwoFormat("ACHDepositAmount1", "ACHDepositAmount1-error-message")
  enforceTwoTwoFormat("ACHDepositAmount2", "ACHDepositAmount2-error-message")

  function handleDescriptorInput(input) {
__ea_trace("modules/consent/consent-ach.ts","handleDescriptorInput",[input],["input"]);
    // Convert to uppercase
    input.value = input.value.toUpperCase()

    const errorMsg = document.getElementById("descriptorCode-error-message")

    // Validate length
    if (input.value.length === 6) {
      errorMsg.innerHTML = ""
    } else {
      errorMsg.innerHTML = "  Must be exactly 6 characters"
    }
  }
  document.getElementById("ach-verification-form").addEventListener("submit", async (e) => {
__ea_trace("modules/consent/consent-ach.ts","(anon)",[e],["e"]);
    e.preventDefault()
    openProgressBar()

    const setup_intent_id = paymentId
    const amount1 = document.getElementById("ACHDepositAmount1").value.trim()
    const amount2 = document.getElementById("ACHDepositAmount2").value.trim()
    const discriptorCode = document.getElementById("descriptorCode").value.trim()
    const resultBox = document.getElementById("finalCheck-error")

    if (microdepostiType === "amounts") {
      if (!setup_intent_id || !amount1 || Number.isNaN(amount1) || !amount2 || Number.isNaN(amount2)) {
        resultBox.textContent = "Please enter valid numbers and payment method ID."
        resultBox.style.color = "red"
        closeProgressBar()
        return
      }
    } else if (microdepostiType === "descriptor_code") {
      if (!setup_intent_id || !discriptorCode) {
        resultBox.textContent = "Please enter valid discriptor Code and payment method ID."
        resultBox.style.color = "red"
        closeProgressBar()
        return
      }
    } else {
      if (!setup_intent_id || !amount1 || Number.isNaN(amount1) || !amount2 || Number.isNaN(amount2)) {
        resultBox.textContent = "Please enter valid numbers and payment method ID."
        resultBox.style.color = "red"
        closeProgressBar()
        return
      }
    }
    try {
      const response = await fetch("https://stripe.nautilussolar.com/stripeserver/ping", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })

      const res = await response.json()
      if (res.success) {
        try {
          if (microdepostiType === "amounts") {
            const response = await fetch("https://stripe.nautilussolar.com/stripeserver/verify/setup-intent", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                setup_intent_id,
                amount1,
                amount2,
              }),
            })

            const data = await response.json()
            if (data.success) {
              resultBox.textContent = data.message
              resultBox.style.color = "green"

              if (skipBayou === "Yes") {
                await updateDealStage("127892571", amount1, amount2, JSON.stringify(data))
                storage.rawSet("typ", "UtAsTaNc")
                storage.rawSet("typ_usage_btn", "Show")
                storage.rawSet("typ_stripe_btn", "Hide")
                updateDealStage("1100007032")
                closeProgressBar()
                window.location.href = "/thank-you"
              } else {
                await updateDealStage("127892570", amount1, amount2, JSON.stringify(data))
                storage.rawSet("typ", "lMiAsTaNc")
                storage.rawSet("DealStage", "Submitted")
                closeProgressBar()
                window.location.href = "/thank-you"
              }
            } else {
              await updateDepositAmount(amount1, amount2, JSON.stringify(data))
              resultBox.textContent =
                "The two deposit amounts that you entered, do not match what Stripe deposited into your account."
              resultBox.style.color = "red"
              closeProgressBar()
            }
          } else if (microdepostiType === "descriptor_code") {
            const response = await fetch("https://stripe.nautilussolar.com/stripeserver/verify/setup-intent", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                setup_intent_id,
                discriptorCode,
              }),
            })

            const data = await response.json()
            if (data.success) {
              resultBox.textContent = data.message
              resultBox.style.color = "green"
              if (skipBayou === "Yes") {
                await updateDealStage("127892571", amount1, amount2, JSON.stringify(data))
                storage.rawSet("typ", "UtAsTaNc")
                storage.rawSet("typ_usage_btn", "Show")
                storage.rawSet("typ_stripe_btn", "Hide")
                updateDealStage("1100007032")
                closeProgressBar()
                window.location.href = "/thank-you"
              } else {
                await updateDealStage("127892570", amount1, amount2, JSON.stringify(data))
                storage.rawSet("typ", "lMiAsTaNc")
                storage.rawSet("DealStage", "Submitted")
                closeProgressBar()
                window.location.href = "/thank-you"
              }
            } else {
              await updateDepositAmount(amount1, amount2, JSON.stringify(data))
              if (
                data.message ===
                'This SetupIntent cannot be actioned on because it has a status of succeeded. Only a SetupIntent with one of the following statuses may be actioned on: ["requires_action"].'
              ) {
                document.getElementById("descriptorCodeLabel").remove()
                document.getElementById("descriptorCode").remove()
                resultBox.textContent = "Your payment method has already been validated. Thank you!"
                resultBox.style.color = "green"
                await updateDealStage("127892570", amount1, amount2, JSON.stringify(data))
                storage.rawSet("typ", "lMiAsTaNc")
                storage.rawSet("DealStage", "Submitted")
                closeProgressBar()
                window.location.href = "/thank-you"
              } else if (data.message === "You have exceeded the number of allowed verification attempts.") {
                document.getElementById("descriptorCodeLabel").remove()
                document.getElementById("descriptorCode").remove()
                resultBox.textContent =
                  "You have reached the maximum number of unsuccessful attempts. Please reach out to Customer Care."
                resultBox.style.color = "red"
              } else {
                document.getElementById("descriptorCode").value = ""
                resultBox.textContent = "This code does not match what we have on file. Please try again."
                resultBox.style.color = "red"
              }
              closeProgressBar()
            }
          } else {
            const response = await fetch("https://stripe.nautilussolar.com/stripeserver/verify/setup-intent", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                setup_intent_id,
                amount1,
                amount2,
              }),
            })

            const data = await response.json()
            if (data.success) {
              resultBox.textContent = data.message
              resultBox.style.color = "green"

              if (skipBayou === "Yes") {
                await updateDealStage("127892571", amount1, amount2, JSON.stringify(data))
                storage.rawSet("typ", "UtAsTaNc")
                storage.rawSet("typ_usage_btn", "Show")
                storage.rawSet("typ_stripe_btn", "Hide")
                updateDealStage("1100007032")
                closeProgressBar()
                window.location.href = "/thank-you"
              } else {
                await updateDealStage("127892570", amount1, amount2, JSON.stringify(data))
                storage.rawSet("typ", "lMiAsTaNc")
                storage.rawSet("DealStage", "Submitted")
                closeProgressBar()
                window.location.href = "/thank-you"
              }
            } else {
              await updateDepositAmount(amount1, amount2, JSON.stringify(data))
              resultBox.textContent =
                "The two deposit amounts that you entered, do not match what Stripe deposited into your account."
              resultBox.style.color = "red"
              closeProgressBar()
            }
          }
        } catch (error) {
          console.error(error)
          resultBox.textContent = "Unexpected error occurred."
          resultBox.style.color = "red"
          closeProgressBar()
        }
      } else {
        resultBox.textContent = "Server error occurred."
        resultBox.style.color = "red"
        closeProgressBar()
      }
    } catch (error) {
      console.error(error)
      resultBox.textContent = "Server error occurred."
      resultBox.style.color = "red"
      closeProgressBar()
    }
  })

  async function updateDealStage(value, amount1, amount2, res) {
__ea_trace("modules/consent/consent-ach.ts","updateDealStage",[value,amount1,amount2,res],["value","amount1","amount2","res"]);
    await delay(2000)
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          dealstage: value,
          ach_deposit_amount_1: amount1,
          ach_deposit_amount_2: amount2,
          ach_verification_manual_response: res,
          billing_status: "verified",
          stripe_payment_status: "verified",
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  async function updateDepositAmount(amount1, amount2, res) {
__ea_trace("modules/consent/consent-ach.ts","updateDepositAmount",[amount1,amount2,res],["amount1","amount2","res"]);
    await delay(2000)
    var dealId = storage.rawGet("dealId")
    var catchdata = ""
    try {
      const data = {
        properties: {
          deal_id: dealId,
          ach_deposit_amount_1: amount1,
          ach_deposit_amount_2: amount2,
          ach_verification_manual_response: res,
        },
      }
      const response = await fetch(apiUrl("UpdateDealRecord"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
      catchdata = data
      if (response.ok) {
      }

      const result = await response.json()
      responseFromAPI = JSON.stringify(result)
    } catch (error) {
      console.error("Error:", error)
    }
    return true
  }
  //- update deaLstage -------------------------------------------------------------------------------
  async function delay(ms) {
__ea_trace("modules/consent/consent-ach.ts","delay",[ms],["ms"]);
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  GetPaymentMethodId()

  var is_enrolled_for_bayou = storage.rawGet("is_enrolled_for_bayou")

  // ─── Wire formerly-inline handlers ────────────────────────────────────────────

  // Descriptor code input formatting (oninput attr stripped from #descriptorCode)
  bind("#descriptorCode", "input", (e) => handleDescriptorInput(e.currentTarget))
}
